import { IAlarmSituation } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'
import Tag from '@/shared/Tags/Tag'

interface IProps {
  level: IAlarmSituation['level']
}

const AlarmSituationLevelTag = (props: IProps) => {
  switch (props.level) {
    case 'CRITICAL':
      return (
        <Tag color="red">
          <p className="text-sm" style={{ color: 'inherit' }}>
            Критично
          </p>
        </Tag>
      )
    case 'DANGER':
      return (
        <Tag color="red">
          <p className="text-sm" style={{ color: 'inherit' }}>
            Опасность
          </p>
        </Tag>
      )
    case 'WARNING':
      return (
        <Tag color="orange">
          <p className="text-sm" style={{ color: 'inherit' }}>
            Предупреждение
          </p>
        </Tag>
      )
  }
}

export default AlarmSituationLevelTag
